import React, {useEffect} from 'react';
import ActionsList from "@components/views/StartPage/ActionsList/Main";
import {bindActionCreators} from "redux";
import {getActionsList, getActionsListInit} from "@store/actions/actionsList";
import {connect} from "react-redux";
import {useMount} from "@s-ui/react-hooks";

const ActionsListContainer = (props) => {
    useMount(() => {
        props.actions.getActionsList();
    });

    useEffect(() => {
        return () => {
            props.actions.getActionsListInit();
        };
    }, [props.actions]);

    return (
        <ActionsList
            actionsItems={props.actionsList.actionsItems}
            errors={props.actionsList.errors}
        />
    );
}

const mapStateToProps = (state) => ({
    actionsList: state.actionsList
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getActionsListInit,
            getActionsList,
        },
        dispatch,
    ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActionsListContainer);